/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hoechsterschulabschluss2Inputs */



/**

* @param {_Field_Hoechsterschulabschluss2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_hoechsterschulabschluss2 = /** @type {((inputs?: _Field_Hoechsterschulabschluss2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hoechsterschulabschluss2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Höchster Schulabschluss")
});
export { _field_hoechsterschulabschluss2 as "_field_hoechsterSchulAbschluss" }